import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

export default function useTermsOfServiceValidationScheme() {
  const { getMessage } = useMessageSource();

  const validateAcceptance = Yup.boolean().oneOf(
    [true],
    getMessage("Validation.message-mustAcceptTermsAndConditions"),
  );

  return Yup.object().shape({
    acceptTermsAndConditions: validateAcceptance,
  });
}
